export const DEBOUNCE_DELAY = 1000 // 1000ms = 1 second

export const HTTP_STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500
  // Add other status codes as needed
}

export const CLIENT_TYPES = [
  { id: 0, name: 'any' },
  { id: 1, name: 'direct' },
  { id: 2, name: 'indirect' },
  { id: 3, name: 'direct_indirect' }
]

export const PRODUCT_STATUS = {
  ACTIVE: 'active',
  DISABLED: 'disabled',
  ARCHIVED: 'archived',
  NOT_APPROVED: 'not_approved',
  VISIBLE_NOT_ALLOWED_TO_BUY: 'visible_not_allowed_to_buy'
}

export const SLIDER_IMAGE_CONFIG = Object.freeze({
  WIDTH: 800,
  HEIGHT: 520,
  ALLOWED_SCALES: [1, 2, 3, 4]
})

export const MAIN_BOX_IMAGE_CONFIG = Object.freeze({
  WIDTH: 368,
  HEIGHT: 150,
  ALLOWED_SCALES: [1, 2, 3, 4]
})
